module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "sign-up-form",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": _vm.submit
    }
  }, [(_vm.forgotPassword == 'notFoundEmail') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.noUserWithEmail')))]) : _vm._e(), (_vm.forgotPassword == 'sent') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.emailSent')))]) : _vm._e(), (_vm.loginState == 'networkError') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.noConnection')))]) : _vm._e(), (_vm.subscribing == 'error') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.fieldsErrors')))]) : _vm._e(), (_vm.subscribing == 'errorEmailExists') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.alreadyUsedEmail')))]) : _vm._e(), (_vm.loginState == 'socialError') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.errorOnSocialAccount')))]) : _vm._e(), (_vm.needConfirmPasswordForSocial) ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.socialAccountWithExistingEmail')))]) : _vm._e(), (_vm.loginState == 'error') ? _c('div', {
    staticClass: "form-group",
    class: _vm.classes("message")
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.badCredentials')))]) : _vm._e(), (_vm.forgotPassword === true) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.forgetPasswordEnterEmail')))]) : _vm._e(), (!_vm.forgotPassword) ? [_c('div', {
    staticClass: "form-group",
    class: _vm.classes('form-group')
  }, [(_vm.forgotPassword != 'sent') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "emailInput",
    staticClass: "form-control",
    attrs: {
      "id": "signinemail",
      "type": "text",
      "placeholder": _vm.emailPlaceholder,
      "disabled": _vm.connectionInputDisabled || _vm.needConfirmPasswordForSocial,
      "name": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryLoginOrTrySubscribe($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    class: _vm.classes('form-group')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "passwordInput",
    staticClass: "form-control",
    attrs: {
      "id": "signinpassword",
      "type": "password",
      "placeholder": _vm.$t("connection.placeholders.password"),
      "disabled": _vm.connectionInputDisabled,
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryLoginOrTrySubscribe($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), (_vm.subscribing) ? [_c('div', {
    staticClass: "form-group",
    class: _vm.classes('form-group')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confPassword),
      expression: "confPassword"
    }],
    ref: "confPasswordInput",
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t("connection.placeholders.confPassword"),
      "disabled": _vm.connectionInputDisabled,
      "name": "confPassword"
    },
    domProps: {
      "value": (_vm.confPassword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryLoginOrTrySubscribe($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confPassword = $event.target.value
      }
    }
  }), (!_vm.passwordAreIdentical) ? _c('div', {
    staticClass: "helper-block"
  }, [_vm._v(_vm._s(_vm.$t('connection.messages.passwordsAreNotSame')))]) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    class: _vm.classes('form-group')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t("connection.placeholders.name"),
      "disabled": _vm.connectionInputDisabled,
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryLoginOrTrySubscribe($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])] : _vm._e()] : [_c('div', {
    staticClass: "form-group",
    class: _vm.classes('form-group')
  }, [(_vm.forgotPassword != 'sent') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.emailPlaceholder,
      "disabled": _vm.connectionInputDisabled,
      "name": "recoveringEmail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendForgotPassword($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }) : _vm._e()])]], 2), (!_vm.forgotPassword) ? [_c('div', {
    staticClass: "socialBtnsRow",
    staticStyle: {
      "clear": "both",
      "text-align": "center"
    }
  }, [(!_vm.needConfirmPasswordForSocial) ? _c('a', {
    staticClass: "sign-up-button btn",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-up",
      "href": "#",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.trySubcribe($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connection.buttons.signup')))]) : _vm._e(), (_vm.subscribing || _vm.needConfirmPasswordForSocial) ? _c('a', {
    staticClass: "sign-up-button btn clickable",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-in",
      "data-wow-delay": "1s",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.stopSubscribing($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.cancel')))]) : _vm._e(), (!_vm.subscribing) ? _c('a', {
    staticClass: "sign-up-button btn clickable",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-in",
      "data-wow-delay": "1s",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.tryLogin($event)
      }
    }
  }, [(!_vm.connectionInputDisabled) ? [_vm._v(_vm._s(_vm.$t('connection.buttons.signin')))] : [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]], 2) : _vm._e()]), _c('div', {
    staticClass: "socialBtnsRow",
    staticStyle: {
      "clear": "both",
      "text-align": "center"
    }
  }, [(!_vm.needConfirmPasswordForSocial) ? _c('button', {
    staticClass: "btn wow fadeInUp",
    class: _vm.classes("socialButton"),
    attrs: {
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": _vm.logWithFacebook
    }
  }, [(_vm.loginState != 'socialLoading' && _vm.loginState != 'socialConnected') ? [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" " + _vm._s(_vm.$t('connection.buttons.byFacebook')))] : [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]], 2) : _vm._e(), (!_vm.needConfirmPasswordForSocial) ? _c('button', {
    staticClass: "btn wow fadeInUp",
    class: _vm.classes("socialButton"),
    attrs: {
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": _vm.logWithGoogle
    }
  }, [(_vm.loginState != 'socialLoading' && _vm.loginState != 'socialConnected') ? [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" " + _vm._s(_vm.$t('connection.buttons.byGoogle')))] : [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]], 2) : _vm._e()]), (!_vm.subscribing) ? _c('div', {
    staticClass: "forgetPassword"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.forgotPassword = true;
        _vm.loginState = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connection.buttons.forgotPassword')))])]) : _vm._e()] : (_vm.forgotPassword != 'sent') ? [_c('div', {
    staticClass: "socialBtnsRow",
    staticStyle: {
      "clear": "both",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "sign-up-button btn",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-up",
      "href": "#",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.sendForgotPassword($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connection.buttons.sendMailForPassword')))]), _c('a', {
    staticClass: "sign-up-button btn clickable",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-in",
      "data-wow-delay": "1s",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.forgotPassword = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.cancel')))])])] : [_c('div', {
    staticClass: "socialBtnsRow",
    staticStyle: {
      "clear": "both",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "sign-up-button btn clickable",
    class: _vm.classes("button"),
    attrs: {
      "id": "sign-in",
      "data-wow-delay": "1s",
      "disabled": _vm.connectionInputDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.forgotPassword = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connection.buttons.backToSingIn')))])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-019daee2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Connection/Connection.vue
// module id = 991
// module chunks = 1 3